<script lang="ts" setup>import { computed as _computed } from 'vue';

import { ISOPRO, InstallationSetup } from '~/models';
import {
  useProductsStore,
  useThresholdsStore,
  useWallStructuresStore,
} from "~/store";
import { LegalFooter } from '~/components';

import PrintPreview from "./PrintPreview.vue";
import PrintOptions from "./PrintOptions.vue";
import { onMounted } from 'vue';
import { matomoAPI } from '~/APIConnection';
import { ScrollbarTiny } from '@pohlcon/design-system';

const products = useProductsStore();
const wallStructures = useWallStructuresStore();

const selectedThickness = _computed(() =>
  wallStructures.selectedThickness);

const selectedWallStructure = _computed(() =>
  wallStructures.selectedWallStructure);

const selectedProduct = _computed(() =>
  products.selectedProduct as ISOPRO | null);

const installationSetup = _computed(() => {
  if (!selectedWallStructure.value || !selectedProduct.value) return null;
  const uThresh = [0]; // TODO: define
  const catAThresh = useThresholdsStore().getCatAByWallStructure(
    selectedProduct.value?.height,
    selectedWallStructure.value.type
  );

  if (!catAThresh) throw new Error('')

  return new InstallationSetup({
    wallStructure: selectedWallStructure.value,
    product: selectedProduct.value,
    catAThresh,
    uThresh,
  });
});

onMounted(() => {
  if (!selectedWallStructure.value || !selectedProduct.value) {
    throw new Error('No wall structure or product selected');
  } else if(!installationSetup.value) {
    throw new Error('No installation setup available');
  }
  else {
    matomoAPI.generalControllerSelected({
      rowKey: selectedProduct.value.rowKey,
      category: installationSetup.value.category ?? 'noCategory'
    });
    if(!installationSetup.value.product.lambdaValue) {
      matomoAPI.generalControllerLambdaNoResult({
        rowKey: selectedProduct.value.rowKey
      });
    }
  }
});
</script>

<template>
  <ScrollbarTiny>
    <div id="print-out">
      <PrintOptions
      v-if="installationSetup"
      :installationSetup="installationSetup"
      v-slot="{ value: optionValues }"
      >
      <PrintPreview
      v-if="installationSetup"
      :installationSetup="installationSetup"
      :selectedThickness="selectedThickness"
      :printOptions="optionValues"
      />
    </PrintOptions>
  </div>
  <LegalFooter />
</ScrollbarTiny>
</template>

<style scoped lang="scss">
</style>
